'use strict';

var tslib = require('tslib');
var React = require('react');
var spinner = require('@alfalab/core-components/spinner');
require('../../../circular-timer/circular-timer.css');
var core_circularTimer_circularTimer = require('../../../circular-timer/circular-timer.js');
var core_statusScreen_statusScreen = require('../../status-screen.js');
require('./time-processing.css');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var StatusScreenTimeProcessing = function (props) {
    props.type; var restProps = tslib.__rest(props, ["type"]);
    // TimerProps не будет работать, если использовать type вместо props.type
    var topAddon = props.type === 'spinner'
        ? React__default.default.createElement(spinner.Spinner, { size: "m", visible: true })
        : React__default.default.createElement(core_circularTimer_circularTimer, tslib.__assign({ className: "status-screen__timer" }, props.timerProps));
    return React__default.default.createElement(core_statusScreen_statusScreen.StatusScreen, tslib.__assign({ topAddons: topAddon }, restProps));
};

exports.StatusScreenTimeProcessing = StatusScreenTimeProcessing;
